module.exports = __webpack_public_path__ + "static/media/artistSpotlight.02b9c37b.png";